import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { H1 } from 'components/common/Text/Text'
import RoundIcon from 'components/common/RoundIcon/RoundIcon'
import PromotionsList from '../PromotionsList'
import Link from 'components/common/Link/Link'

const PromotionResultList = ({
  promotionResultList = [],
  subtitle,
  title,
  regionName,
  noPromotionsMessage,
  isBlackFridayPage
}) =>
  <Wrapper id="promotion-result-list">
    { regionName ?
      <RegionTitle headline centered>
        <DealsIcon medium inline asset="deal-red" />
        <DealsText>
          {`Deals in ${regionName}`}
        </DealsText>
      </RegionTitle> :
      !isBlackFridayPage && <Title headline_narrow headline centered>
        { title }
      </Title>
    }
    {
      subtitle &&
        <Description>{ subtitle }</Description>
    }
    <PromotionsList
      regionName={ regionName }
      promotionResultList={ promotionResultList }
      noPromotionsMessage={ noPromotionsMessage } />

    {isBlackFridayPage && (
      <DealsLinkText>
        For full promotional details, please visit <DealsLink to="/deals">www.bigotires.com/deals</DealsLink>.
      </DealsLinkText>
    )}
  </Wrapper>

PromotionResultList.propTypes = {
  isBlackFridayPage: PropTypes.bool,
  noPromotionsMessage: PropTypes.string,
  promotionResultList: PropTypes.arrayOf(PropTypes.shape()),
  regionName: PropTypes.string,
  subtitle: PropTypes.string,
  title: PropTypes.string
}

export default PromotionResultList

const Wrapper = styled.div`
  ${Mixin.responsive('margin', '0 auto 0', '15px auto 0')}
  ${Mixin.responsive('text-align', 'left', 'center')}
  ${Mixin.clearFix()}

  [data-breadcrumb] + & {
    ${Mixin.responsive('margin', '75px auto 0', '15px auto 0')}
  }
`

const Title = styled(H1)`
  text-align: center;
  ${Mixin.font.GothamBold(34)}
  ${Mixin.responsive('margin', '0 8px 14px 8px', '0 8px 10px 8px')}
  ${Media.mobile`
    ${Mixin.font.GothamBold(22)}
    padding: 15px 0;
  `}
  ${Media.mobileNarrow`
    padding-bottom: 25px;
  `}
`

const RegionTitle = styled.div`
  text-align: center;
  ${Mixin.responsive('margin', '0 0 26px', '0 0 18px')}
`

const Description = styled.p`
  text-align: center;
  ${Mixin.responsive('font-size', '20px', '16px')}
  ${Mixin.responsive('margin', '0 8px 42px 8px', '0 8px 34px 8px')}
`

const DealsIcon = styled(RoundIcon)`
  margin-right: 10px;
  ${Mixin.responsive('vertical-align', '6px', '4px')}
  ${Media.mobileNarrow`
    margin-bottom: 10px;
  `}
`

const DealsText = styled.span`
  display: inline-block;
  text-transform: uppercase;
  ${Mixin.font.GothamBold(26)}
  ${Media.mobile`
    ${Mixin.font.GothamBold(18)}
    padding: 0 5px;
  `}
`

const DealsLinkText = styled.p`
  margin: 30px 0;
  font-size: 18px;
  text-align: center;
`

const DealsLink = styled(Link)`
  text-decoration: underline;
  font-size: 18px;
`
